export enum CodatCompanyRefreshRequestStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Succeeded = 'succeeded',
    Failed = 'failed',
    Canceled = 'canceled',
}
